exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sms_item[data-v-3d6414c6]{padding:20px;border:1px solid #e6e6e6;margin-bottom:20px}.form_item[data-v-3d6414c6]{display:-webkit-box;display:-ms-flexbox;display:flex}.form_item label[data-v-3d6414c6],.form_item p[data-v-3d6414c6],.form_item span[data-v-3d6414c6]{font-size:12px;line-height:23px}.right[data-v-3d6414c6]{margin-left:20px;background-color:#f5f5f5}.right .header[data-v-3d6414c6]{padding:10px 15px;border-bottom:1px solid #e6e6e6}.send_mobile[data-v-3d6414c6] .el-input__inner{height:30px;line-height:30px}.send_mobile[data-v-3d6414c6] .el-input__icon{line-height:30px}\n", ""]);

// exports
